/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../resources/datatypes';
import '../../resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "UpdateCatalogObjectsRequest": {
                        "fields": {
                          "updates": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObjectBatch",
                            "id": 1,
                            "rule": "required"
                          },
                          "fieldsToClear": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "UpdateCatalogObjectsResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "objects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "updatedAt": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "idMappings": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogIdMapping",
                            "id": 4,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.UpdateCatalogObjectsRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.UpdateCatalogObjectsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateCatalogObjectsRequest @ squareup/connect/v2/catalog/interfaces/update-catalog-objects.proto at 19:1
 */
export const UpdateCatalogObjectsRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.UpdateCatalogObjectsRequest');
fixType(UpdateCatalogObjectsRequest, {
  updates: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateCatalogObjectsRequest);
/**
 * SOURCE UpdateCatalogObjectsResponse @ squareup/connect/v2/catalog/interfaces/update-catalog-objects.proto at 37:1
 */
export const UpdateCatalogObjectsResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.UpdateCatalogObjectsResponse');
fixType(UpdateCatalogObjectsResponse);
Builder.createAndAttachToType(UpdateCatalogObjectsResponse);